import React, { useEffect, useState } from "react";
import MoneyDisplay from "./MoneyDisplay";
import MoneyDisplayCount from "./MoneyDisplayCount";
import CustomBtn from "components/fragments/CustomBtn";
import CustomInput from "components/fragments/CustomInput";
import { numberWithTwoDecimals } from "utils/numberFormat";

export default function MoneyCountController({
  startValueObj,
  info,
  isResetObj,
  viaPaymentInfoObj,
  isCloseBalance = false,
  isCloseBalanceCfObg
}) {
  const [sumValue, setSumValue] = useState("0.00");

  const handleInputChange = (index, value) => {
    const updatedRowValues = [...rowValues];
    updatedRowValues[index].displayCount.currentValue = parseFloat(value) || 0;
    setRowValues(updatedRowValues);
  };
  const calculateRowSum = () => {
    return rowValues.reduce((sum, item) => {
      return sum + item.display.value * item.displayCount.currentValue;
    }, 0);
  };

  const initRowValues = [
    {
      display: {
        value: 1000,
        isBankNote: true,
      },
      displayCount: {
        countValue: 0,
        currentValue: 0,
        isActive: false,
      },
    },
    {
      display: {
        value: 500,
        isBankNote: true,
      },
      displayCount: {
        countValue: 0,
        currentValue: 0,
        isActive: false,
      },
    },
    {
      display: {
        value: 100,
        isBankNote: true,
      },
      displayCount: {
        countValue: 0,
        currentValue: 0,
        isActive: false,
      },
    },
    {
      display: {
        value: 50,
        isBankNote: false,
      },
      displayCount: {
        countValue: 0,
        currentValue: 0,
        isActive: false,
      },
    },
    {
      display: {
        value: 20,
        isBankNote: false,
      },
      displayCount: {
        countValue: 0,
        currentValue: 0,
        isActive: false,
      },
    },
    {
      display: {
        value: 10,
        isBankNote: false,
      },
      displayCount: {
        countValue: 0,
        currentValue: 0,
        isActive: false,
      },
    },
    {
      display: {
        value: 5,
        isBankNote: false,
      },
      displayCount: {
        countValue: 0,
        currentValue: 0,
        isActive: false,
      },
    },
    {
      display: {
        value: 1,
        isBankNote: false,
      },
      displayCount: {
        countValue: 0,
        currentValue: 0,
        isActive: false,
      },
    },
  ];
  const [rowValues, setRowValues] = useState(initRowValues);

  const resetAllValue = () => {
    startValueObj.setStartValue("0.00");
    setRowValues(initRowValues);
  };

  useEffect(() => {
    setSumValue(calculateRowSum());
  }, [rowValues]);

  useEffect(() => {
    if (isResetObj.isReset) {
      resetAllValue();
      isResetObj.setIsReset(false);
    }
  }, [isResetObj.isReset]);

  useEffect(() => {
    if (isCloseBalance) {
      startValueObj.setStartValue(sumValue);
    }
    if (isCloseBalance && viaPaymentInfoObj) {
      viaPaymentInfoObj.setViaPaymentInfo({
        ...viaPaymentInfoObj.viaPaymentInfo,
        diffTotal: sumValue - viaPaymentInfoObj.viaPaymentInfo.cashTotal,
      });
      isCloseBalanceCfObg.setIsCloseBalanceConfirm(false);
    }
  }, [isCloseBalance, sumValue]);

  useEffect(() => {
    if (isCloseBalance) {
      const testRowValues = [
        {
          display: {
            value: 1000,
            isBankNote: true,
          },
          displayCount: {
            countValue: 25000,
            currentValue: 25,
            isActive: false,
          },
        },
        {
          display: {
            value: 500,
            isBankNote: true,
          },
          displayCount: {
            countValue: 5000,
            currentValue: 10,
            isActive: false,
          },
        },
        {
          display: {
            value: 100,
            isBankNote: true,
          },
          displayCount: {
            countValue: 2500,
            currentValue: 25,
            isActive: false,
          },
        },
        {
          display: {
            value: 50,
            isBankNote: false,
          },
          displayCount: {
            countValue: 1000,
            currentValue: 20,
            isActive: false,
          },
        },
        {
          display: {
            value: 20,
            isBankNote: false,
          },
          displayCount: {
            countValue: 400,
            currentValue: 20,
            isActive: false,
          },
        },
        {
          display: {
            value: 10,
            isBankNote: false,
          },
          displayCount: {
            countValue: 450,
            currentValue: 45,
            isActive: false,
          },
        },
        {
          display: {
            value: 5,
            isBankNote: false,
          },
          displayCount: {
            countValue: 500,
            currentValue: 100,
            isActive: false,
          },
        },
        {
          display: {
            value: 1,
            isBankNote: false,
          },
          displayCount: {
            countValue: 100,
            currentValue: 100,
            isActive: false,
          },
        },
      ];
      setRowValues(testRowValues);
    }
  }, [isCloseBalance]);

  return (
    <div className="w-full">
      <div className="flex justify-between mt-[min(0.98vw,10px)]">
        <div className="w-[min(26.86vw,275px)]">
          <div className="font-[500] leading-[2] text-20">{info.cashierName}</div>
          <div className="bg-[#EDEDED] w-full h-[min(0.10vw,1px)]"></div>
          <div className="mt-[min(1.76vw,18px)] flex flex-col gap-[min(0.78vw,8px)] text-18">
            <div className="flex justify-between gap-[min(0.98vw,10px)] text-18">
              <div className="whitespace-nowrap text-[#474747]">
                ชื่อพนักงาน :
              </div>
              <div className="truncate">{info.staffName}</div>
            </div>
            <div className="flex justify-between gap-[min(0.98vw,10px)]  text-18">
              <div className="whitespace-nowrap text-[#474747]">
                เวลาเริ่มขาย :
              </div>
              <div className="truncate">{info.startTime ?? "-"}</div>
            </div>
            {/* <div className="flex justify-between gap-[min(0.98vw,10px)]  text-18">
              <div className="whitespace-nowrap text-[#474747]">
                เวลาสิ้นสุด :
              </div>
              <div className="truncate">{info.endTime ?? "-"}</div>
            </div> */}
            {/* <div className="flex justify-between gap-[min(0.98vw,10px)]  text-18">
              <div className="whitespace-nowrap text-[#474747]">
                ระยะเวลาขาย :
              </div>
              <div className="truncate">{info.duration ?? "-"}</div>
            </div> */}
            {!isCloseBalance && (
              <div className="flex items-center justify-between gap-[min(0.98vw,10px)]">
                <div className="whitespace-nowrap text-[#474747]">
                  {info.eventTxt ?? "เงินสดตั้งต้น"} :
                </div>
                <div className="w-[min(9.77vw,100px)]">
                  <CustomInput
                    inputprops={{
                      type: "text",
                      readOnly: 'readOnly',
                      className: "modal-input no-spinner text-18 disabled-input",
                      value: numberWithTwoDecimals(startValueObj.startValue),
                      min: 0,
                      onChange: (e) => {
                        const inputValue = parseFloat(e.currentTarget.value);
                        const roundedValue = Math.round(inputValue * 100) / 100;
                        startValueObj.setStartValue(roundedValue);
                      },
                      onClick: (e) => {
                        const input = e.target;
                        input.select();
                      },
                    }}
                  />
                </div>
              </div>
            )}

            {isCloseBalance && (
              <>
                <div className="flex justify-between gap-[min(0.98vw,10px)]  text-18">
                  <div className="whitespace-nowrap text-[#474747]">
                    {info.eventTxt ?? "เงินสดตั้งต้น"} :
                  </div>
                  <div className="text-[var(--color-green)] truncate">
                    {info.startValue
                      ? numberWithTwoDecimals(info.startValue)
                      : "-"}
                  </div>
                </div>
                <div className="flex justify-between gap-[min(0.98vw,10px)]  text-18">
                  <div className="whitespace-nowrap text-[#474747]">
                    นำเงินเข้ารวม :
                  </div>
                  <div className="text-[var(--color-green)] truncate">
                    {info.totalDeposit
                      ? numberWithTwoDecimals(info.totalDeposit)
                      : "-"}
                  </div>
                </div>
                <div className="flex justify-between gap-[min(0.98vw,10px)]  text-18">
                  <div className="whitespace-nowrap text-[#474747]">
                    นำเงินออกรวม :
                  </div>
                  <div className="text-[var(--color-red)] truncate">
                    {info.totalWithDraw
                      ? numberWithTwoDecimals(info.totalWithDraw * -1)
                      : "-"}
                  </div>
                </div>
                <div className="flex justify-between gap-[min(0.98vw,10px)]  text-18">
                  <div className="whitespace-nowrap text-[#474747]">ยอดขาย :</div>
                  <div
                    className={`${
                      info.grandTotal ? "text-[var(--color-green)]" : ""
                    } truncate`}
                  >
                    {info.grandTotal ? numberWithTwoDecimals(info.grandTotal) : "-"}
                  </div>
                </div>

                <div className="flex justify-between gap-[min(0.98vw,10px)]  text-18">
                  <div className="whitespace-nowrap text-[#474747]">รายได้ค่าธรรมเนียม :</div>
                  <div
                    className={`${
                      info.feeIncome ? "text-[var(--color-green)]" : ""
                    } truncate`}
                  >
                    {info.feeIncome ? numberWithTwoDecimals(info.feeIncome) : "-"}
                  </div>
                </div>

                <div className="flex justify-between gap-[min(0.98vw,10px)]  text-18">
                  <div className="whitespace-nowrap text-[#474747]">รวม :</div>
                  <div
                    className={`${
                      info.grandTotal ? "text-[var(--color-green)]" : ""
                    } truncate`}
                  >
                    {info.grandTotal ? numberWithTwoDecimals(info.grandTotal+info.feeIncome) : "-"}
                  </div>
                </div>
              </>
            )}

            
            {/* {!isCloseBalance && (
              <div className="flex justify-between gap-[min(0.98vw,10px)]  text-18">
                <div className="whitespace-nowrap text-[#474747]">
                  เงินสดปิดยอด :
                </div>
                <div className="truncate">-</div>
              </div>
            )} */}
          </div>
        </div>
        <div className="w-[min(22.07vw,226px)]">
          <div className="leading-[2] text-20">ตัวช่วยนับเงิน</div>
          <div className="bg-[#EDEDED] w-full h-[min(0.10vw,1px)]"></div>
          <div className="flex flex-col gap-[min(0.91vw,9.28px)] mt-[min(1.76vw,18px)]">
            {rowValues.map((value, index) => {
              return (
                <div key={index} className="flex justify-between">
                  <MoneyDisplay
                    value={value.display.value}
                    isBankNote={value.display.isBankNote}
                  />
                  <MoneyDisplayCount
                    index={index}
                    currentValue={value.displayCount.currentValue}
                    countValue={
                      value.displayCount.currentValue * value.display.value
                    }
                    isActive={
                      value.displayCount.currentValue * value.display.value > 0
                    }
                    isCloseBalance={isCloseBalance}
                    handleInputChange={handleInputChange}
                  />
                </div>
              );
            })}
          </div>
          <div className="flex justify-between mt-[min(1.46vw,15px)]">
            <div className="text-18 text-[var(--color-grey-2)]">Total</div>
            <div className="w-[min(9.77vw,100px)] bg-[#F4F4F4] truncate flex justify-center items-center rounded-[min(0.20vw,2px)]">
              {numberWithTwoDecimals(sumValue)}
            </div>
            {!isCloseBalance && (
              <CustomBtn
                onClick={() =>
                  startValueObj.setStartValue(parseFloat(sumValue).toFixed(2))
                }
                className={
                  "btn-main-active min-w-[min(6.74vw,69px)] text-white leading-[0.8] font-[400] text-16 pt-[min(1.27vw,13px)] pb-[min(0.78vw,8px)] rounded-[min(0.20vw,2px)]"
                }
                btntxt={info.calTxt}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
